import { api } from './api';

export async function getBadges() {
  try {
    const { data } = await api.get(`challenge`, {
      params: { orderby: 'extra.order', reverse: true, q: "'extra.hidden':null" },
    });
    if (!Array.isArray(data)) {
      return [];
    } else {
      return data.filter(item => item.techniques?.includes('GT02'));
    }
  } catch {
    return [];
  }
}

export async function getAllBadges() {
  try {
    const { data } = await api.get(`challenge`);
    if (!Array.isArray(data)) {
      return [];
    } else {
      return data.filter((item: any) => item.techniques?.includes('GT02'));
    }
  } catch {
    return [];
  }
}

export async function getAllChallengesWithBadge() {
  try {
    const { data } = await api.get(`challenge`);
    if (!Array.isArray(data)) {
      return [];
    } else {
      return data.filter((item: any) => item.badge?.small?.url);
    }
  } catch {
    return [];
  }
}
